
export default function ContactInfo() {
  return (
    <div className="space-y-8">
      {/* Contact Information */}
      <div className="bg-white rounded-xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">お問い合わせ先</h2>
        
        <div className="space-y-6">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-map-pin-line text-blue-600"></i>
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">本社所在地</h3>
              <p className="text-gray-600">
                〒339-0057<br />
                埼玉県さいたま市岩槻区本町1丁目5-4　松永ビル5F
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-phone-line text-green-600"></i>
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">電話番号</h3>
              <p className="text-gray-600">080-1154-9876（緊急）</p>
              <p className="text-sm text-gray-500 mt-1">受付時間：平日 9:00〜18:00</p>
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-mail-line text-orange-600"></i>
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">メールアドレス</h3>
              <p className="text-gray-600">masuno@mkf23.com</p>
              <p className="text-sm text-gray-500 mt-1">24時間受付</p>
            </div>
          </div>
        </div>
      </div>

      {/* Business Hours */}
      <div className="bg-white rounded-xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">営業時間・対応エリア</h2>
        
        <div className="space-y-6">
          <div>
            <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-time-line text-blue-600"></i>
              </div>
              営業時間
            </h3>
            <div className="bg-gray-50 rounded-lg p-4">
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="font-medium text-gray-700">平日</p>
                  <p className="text-gray-600">9:00 - 18:00</p>
                </div>
                <div>
                  <p className="font-medium text-gray-700">土日祝</p>
                  <p className="text-gray-600">要相談</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-3 flex items-center">
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-roadster-line text-blue-600"></i>
              </div>
              対応エリア
            </h3>
            <div className="bg-gray-50 rounded-lg p-4">
              <p className="text-gray-700 mb-2">
                <span className="font-medium">主要対応エリア：</span>全国対応
              </p>
              <p className="text-sm text-gray-600">
                全国どちらの地域でも対応いたします。
                現地調査・お打ち合わせは要予約となります。
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Services Overview */}
      <div className="bg-blue-50 rounded-xl p-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">主要サービス</h2>
        
        <div className="grid grid-cols-1 gap-4">
          <div className="flex items-center space-x-3">
            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
            <span className="text-gray-700">住宅・商業施設のリノベーション</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
            <span className="text-gray-700">ファシリティマネジメント・メンテナンス</span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
            <span className="text-gray-700">建設・不動産コンサルティング</span>
          </div>
        </div>
        
        <div className="mt-6 p-4 bg-white rounded-lg">
          <p className="text-sm text-gray-600">
            <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
              <i className="ri-information-line text-blue-600"></i>
            </span>
            無料見積り・現地調査を承っております。お気軽にお問い合わせください。
          </p>
        </div>
      </div>
    </div>
  );
}
